import { graphql } from "gatsby"
import React from "react"
import Footer from "../../../components/shared/footer"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import FixedHeaderSpacer from "../../atoms/fixed-header-spacer"
import Link from "../../atoms/link"
import InternalRoutes from "../../util/internal-routes"
import ListingArticles from "../article-listing/articles"
import ListingBreadcrumbs from "../article-listing/breadcrumbs"
import ListingHeader from "../article-listing/header"
import ListingPagination from "../article-listing/pagination"
import SdkBlocks from "../sdk-blocks"

/**
 * The Developers Page is a slightly different category page than all the rest.
 */
const DevelopersPage = ({ data: { articles }, location, pageContext }) => {
  const category = {
    name: pageContext.name,
    slug: pageContext.slug,
  }
  const { numPages, currentPage } = pageContext
  return (
    <Layout showBackground={true} location={location}>
      <SEO title={category.name} />
      <FixedHeaderSpacer />
      <ListingBreadcrumbs>
        <Link to={InternalRoutes.Blog()}>Home</Link>
        <Link to={InternalRoutes.Blog(category)}>{category.name}</Link>
      </ListingBreadcrumbs>
      <ListingHeader
        title={category.name}
        subtitle={`${articles.totalCount} Article${
          articles.totalCount > 1 ? `s` : ``
        }`}
      />
      <ListingArticles articles={articles.edges} />
      <ListingPagination
        currentPage={currentPage}
        totalPages={numPages}
        pagePrefix={InternalRoutes.Blog(category)}
      />
      <SdkBlocks />
      <Footer />
    </Layout>
  )
}

export default DevelopersPage

export const developersPageQuery = graphql`
  query ($slug: String, $limit: Int, $skip: Int) {
    articles: allContentfulBlogPost(
      limit: $limit
      skip: $skip
      sort: { fields: publishDate, order: DESC }
      filter: { tags: { category: { slug: { eq: $slug } } } }
    ) {
      edges {
        node {
          ...ContentfulBlogPostFragment
        }
      }
      totalCount
    }
  }
`
